module.exports = __webpack_public_path__ + "static/media/009.259ac5c2.jpg";